import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertTriangle, BellRing, Clock } from "lucide-react";
import { api, fmtDateTime } from "../../lib/api";
import { Button } from "../ui/button";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "../ui/dialog";

export function TaskReminderPopup() {
  const [items, setItems] = useState([]);
  const navigate = useNavigate();
  useEffect(() => {
    const f = () => api.get("/admin-tasks/popups").then((r) => setItems(r.data)).catch(() => {});
    f();
    const t = setInterval(f, 30000);
    return () => clearInterval(t);
  }, []);
  const close = async (go) => {
    setItems([]);
    api.post("/admin-tasks/popups/seen").catch(() => {});
    if (go) navigate("/tugas-admin");
  };
  if (!items.length) return null;
  return (
    <Dialog open onOpenChange={() => close(false)}>
      <DialogContent className="max-w-md border-[#F04E23]/40" data-testid="task-reminder-popup">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><BellRing className="w-5 h-5 text-[#F04E23] animate-pulse" /> {items[0].task_id === "absen" ? "Pengingat Absensi" : `Pengingat Tugas dari ${items[0].by_name}`}</DialogTitle>
          <DialogDescription>{items.some((p) => p.task_id === "absen") ? "Anda belum absen masuk. " : ""}{items.filter((p) => p.task_id !== "absen").length ? `${items.filter((p) => p.task_id !== "absen").length} tugas perlu ditindaklanjuti (terima / isi progres).` : ""}</DialogDescription>
        </DialogHeader>
        <div className="space-y-2 max-h-[55vh] overflow-y-auto">
          {items.map((p) => (
            <div key={p.id} className={`rounded-lg border p-3 text-sm ${p.overdue ? "border-rose-500/50 bg-rose-500/5" : "border-amber-500/40 bg-amber-500/5"}`} data-testid={`task-reminder-${p.task_id}`}>
              <div className="flex items-center gap-2 font-semibold">
                {p.overdue ? <AlertTriangle className="w-4 h-4 text-rose-400 shrink-0" /> : <Clock className="w-4 h-4 text-amber-400 shrink-0" />}
                <span className="flex-1 truncate">{p.title}</span>
                <span className="text-[10px] uppercase font-mono text-muted-foreground">{p.status} {p.percent}%</span>
              </div>
              {p.deadline && <div className="text-xs text-muted-foreground mt-1">Target: <span className={`font-mono ${p.overdue ? "text-rose-400 font-semibold" : ""}`}>{fmtDateTime(p.deadline)}</span>{p.overdue && " — TERLAMBAT"}</div>}
              {p.note && <div className="text-xs mt-1 italic">"{p.note}"</div>}
            </div>
          ))}
        </div>
        <div className="flex gap-2">
          <Button className="flex-1 bg-[#F04E23] hover:bg-[#d8431c] text-white" onClick={() => close(true)} data-testid="task-reminder-open">Buka Tugas Admin</Button>
          <Button variant="outline" onClick={() => close(false)} data-testid="task-reminder-dismiss">Mengerti</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
